/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var NewsletterModal = (function (_Component) {
	_inherits(NewsletterModal, _Component);

	function NewsletterModal() {
		_classCallCheck(this, NewsletterModal);

		_Component.apply(this, arguments);
	}

	NewsletterModal.prototype.render = function render() {
		var styles = require('./NewsletterModal.css');

		return _react2['default'].createElement(
			'form',
			{ action: '//baltimorebrew.us4.list-manage.com/subscribe/post?u=e16fe3f86f4146722d64dcc06&id=bfe8fc4b48', method: 'post', id: 'mc-embedded-subscribe-form', name: 'mc-embedded-subscribe-form', target: '_blank', noValidate: true },
			_react2['default'].createElement(
				'fieldset',
				{ className: styles.Fieldset },
				_react2['default'].createElement('input', { className: styles.Input, type: 'text', name: 'FNAME', id: 'mce-FNAME', placeholder: 'First Name' }),
				_react2['default'].createElement('input', { className: styles.Input, type: 'email', name: 'EMAIL', id: 'mce-EMAIL', placeholder: 'Email' }),
				_react2['default'].createElement(
					'div',
					{ className: styles.FormGroup },
					_react2['default'].createElement(
						'h2',
						{ className: styles.H2 },
						'Brew Email Blasts'
					),
					_react2['default'].createElement(
						'label',
						{ className: styles.Label },
						_react2['default'].createElement('input', { type: 'checkbox', value: '32', name: 'group[1229][32]', id: 'mce-group[1229]-1229-0', defaultChecked: true }),
						' Weekly News Updates'
					),
					_react2['default'].createElement(
						'label',
						{ className: styles.Label },
						_react2['default'].createElement('input', { type: 'checkbox', value: '64', name: 'group[1229][64]', id: 'mce-group[1229]-1229-1', defaultChecked: true }),
						' Special Message From The Brew'
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.FormGroup },
					_react2['default'].createElement(
						'h2',
						{ className: styles.H2 },
						'Email Format'
					),
					_react2['default'].createElement(
						'label',
						{ className: styles.Label },
						_react2['default'].createElement('input', { type: 'radio', value: 'html', name: 'EMAILTYPE', id: 'mce-EMAILTYPE-0', defaultChecked: true }),
						' HTML'
					),
					_react2['default'].createElement(
						'label',
						{ className: styles.Label },
						_react2['default'].createElement('input', { type: 'radio', value: 'text', name: 'EMAILTYPE', id: 'mce-EMAILTYPE-1' }),
						' Text'
					)
				),
				_react2['default'].createElement(
					'div',
					{ style: { position: 'absolute', left: '-5000px' }, 'aria-hidden': 'true' },
					_react2['default'].createElement('input', { type: 'text', name: 'b_e16fe3f86f4146722d64dcc06_bfe8fc4b48', tabIndex: '-1', value: '' })
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.FormGroup },
					_react2['default'].createElement(
						'button',
						{ className: styles.Button },
						'Subscribe'
					)
				)
			)
		);
	};

	return NewsletterModal;
})(_react.Component);

exports['default'] = NewsletterModal;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewsletterModal/NewsletterModal.js
 ** module id = 687
 ** module chunks = 0
 **/